module.exports = __webpack_public_path__ + "static/media/str-group-color.eb81fc59.svg";